import _ from 'lodash'

export default {
    roomMedia: function(state, getters, rootState, rootGetters){
        return rootState.room.roomMedia;
    },
    getRoomMedia: (state, getters, rootState, rootGetters) => (roomGroupId) => {
        let roomGroup = rootGetters["roomGroup/getRoomGroup"](roomGroupId);
        if(!roomGroup){
            console.warn('roomGroup is null :', roomGroupId);
            return null;
        }
        return roomGroup.roomMedia;
    },
    getRoomMediaFiles: (state, getters, rootState) => ({roomGroupId}) => {
        let roomMedia = getters.getRoomMedia(roomGroupId);
        if(!roomMedia){
            return null;
        }
        return roomMedia.roomMediaFiles;
    },
    uploadRoomMediaFiles: (state) => {
        return state.uploadRoomMediaFiles
    },
    getUploadRoomMediaFile: (state, getters) => (id) =>{
        return getters.uploadRoomMediaFiles.find(obj => obj.id === id)
    },
    getMediaFile: (state, getters, rootState) => ({roomGroupId, mediaId}) => {
        let roomMedia = getters.getRoomMedia(roomGroupId);
        if(!roomMedia){
            return null;
        }
        let idx = roomMedia.roomMediaFiles.findIndex(roomMediaFile => roomMediaFile.mediaFile.mediaId == mediaId);
        if(idx < 0) return null;
        return roomMedia.roomMediaFiles[idx].mediaFile;
    },
    getRoomMediaFile: (state, getters, rootState) => ({mediaId, roomGroupId}) => {
        let roomMedia = getters.getRoomMedia(roomGroupId);
        if(!roomMedia){
            return null;
        }
        let roomMediaFile = roomMedia.roomMediaFiles.find(file => file.mediaId == mediaId);
        return roomMediaFile;
    },
    allowedFileExts: (state) => {
        return state.allowedFileExts
    },
    isAudio: (state) => ({fileExt}) => {
        return state.audioFileExts.includes(fileExt)
    },
    isVideo: (state) => ({fileExt}) => {
        return state.videoFileExts.includes(fileExt)
    },
    isInit: (state) => {
        return state.init;
    },
    sortedRoomMediaFile: (state, getters, rootState) => ({roomGroupId}) => {
        let roomMediaFiles = getters.getRoomMediaFiles({roomGroupId})
        return _.sortBy(roomMediaFiles, 'seqNo')
    },
    getNextRoomMediaFile: (state, getters, rootState) => ({mediaId, roomGroupId}) => {
        let roomMediaFiles = getters.sortedRoomMediaFile({roomGroupId})
        let idx = roomMediaFiles.findIndex(roomMediaFile => roomMediaFile.mediaId === mediaId)
        return roomMediaFiles[(idx+1) % roomMediaFiles.length]
    }
}
